/* eslint-disable react/jsx-no-bind */
import MainCard from 'ui-component/cards/MainCard';
import { Button, TextField, IconButton, CircularProgress } from '@mui/material';
import { Worker, Viewer, ViewMode, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';
import { selectionModePlugin, SelectionMode } from '@react-pdf-viewer/selection-mode';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import '@react-pdf-viewer/selection-mode/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import react from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { UserData } from 'utils/userData';
import Card from '@mui/material/Card';
import Collapse from '@mui/material/Collapse';
import CardHeader from '@mui/material/CardHeader';
import Container from '@mui/material/Container';
import CardContent from '@mui/material/CardContent';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LoadingButton from '@mui/lab/LoadingButton';

const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    width: 100%;
    padding: 20px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 5px;
`;

const UploadAdditionalReport = () => {
    const zoomPluginInstance = zoomPlugin({ enableShortcuts: true });
    const { ZoomIn, ZoomOut, Zoom } = zoomPluginInstance;
    const selectionModePluginInstance = selectionModePlugin({ selectionMode: SelectionMode.Hand });
    const thumbnailPluginInstance = thumbnailPlugin();
    const { Thumbnails } = thumbnailPluginInstance;

    const finalPermission = UserData().permissions;
    const uploadReport = finalPermission?.find((permission) => permission.name === 'Upload Reports');

    const location = useLocation();
    const navigate = useNavigate();

    const { id, name, email, phone, customerId } = location.state || {};

    const fileInputRef = react.useRef(null);
    const [reports, setReports] = react.useState([]);
    const [loadingReports, setLoadingReports] = react.useState(false);
    const [reportName, setReportName] = react.useState('');
    const [selectedFile, setSelectedFile] = react.useState(null);
    const [openCardIndex, setOpenCardIndex] = react.useState(null);
    const [open, setOpen] = react.useState(false);
    const [uploadLoad, setUploadLoad] = react.useState(false);
    const [apiResponse, setApiResponse] = react.useState('');
    const [toastMessage, setToastMessage] = react.useState('');

    const Alert = react.forwardRef((props, ref) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

    const getReports = react.useCallback(() => {
        setLoadingReports(true);
        axios
            .get(`${process.env.REACT_APP_BASEURL}admin/user/getAdditionalReports`, { params: { user_id: id } })
            .then((response) => {
                setReports(response.data.data || []);
                setLoadingReports(false);
            })
            .catch(() => {
                setLoadingReports(false);
            });
    }, [id]);

    react.useEffect(() => {
        if (id) getReports();
    }, [id, getReports]);

    const toggleCard = (index) => {
        setOpenCardIndex((prev) => (prev === index ? null : index));
    };

    const fileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedFile(e.target.files[0]);
        }
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setUploadLoad(true);
        const formData = new FormData();
        formData.append('user_id', id);
        formData.append('report_name', reportName);
        formData.append('report_file', selectedFile);

        axios
            .post(`${process.env.REACT_APP_BASEURL}admin/user/uploadAdditionalReport`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then((response) => {
                setUploadLoad(false);
                setApiResponse('success');
                setToastMessage(response.data.message);
                setOpen(true);
                setReportName('');
                setSelectedFile(null);
                if (fileInputRef.current) fileInputRef.current.value = '';
                getReports();
            })
            .catch((error) => {
                setUploadLoad(false);
                setApiResponse('error');
                setToastMessage(error.response.data.message);
                setOpen(true);
            });
    };

    return (
        <div>
            <Button onClick={() => navigate(-1)} style={{ color: 'darkgrey' }}>
                ← Back
            </Button>
            <br />
            <Snackbar open={open} autoHideDuration={6000} style={{ alignItems: 'center' }} onClose={handleClose}>
                <Alert onClose={handleClose} severity={apiResponse} sx={{ width: '100%' }}>
                    {toastMessage}
                </Alert>
            </Snackbar>
            <MainCard>
                <h1>Upload Additional Report</h1>
                <br />
                <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ width: '35%' }}>
                        <Form onSubmit={onSubmit}>
                            <h3>Customer Name: {capitalize(name)}</h3>
                            {customerId && customerId !== '' && customerId !== 'undefined' && customerId !== 'null' ? (
                                <h3>Customer Id : {customerId}</h3>
                            ) : (
                                <h3>Customer Id : Not available</h3>
                            )}
                            {email && email !== '' && email !== 'undefined' && email !== 'null' ? (
                                <h3>Email : {email}</h3>
                            ) : (
                                <h3>Email : Not available</h3>
                            )}
                            {phone && phone !== '' && phone !== 'undefined' && phone !== 'null' ? (
                                <h3>Phone : {phone}</h3>
                            ) : (
                                <h3>Phone : Not available</h3>
                            )}

                            <br />
                            <TextField
                                label="Report Name"
                                placeholder="Report Name"
                                variant="outlined"
                                disabled={!uploadReport?.can_create}
                                value={reportName}
                                onChange={(e) => setReportName(e.target.value)}
                            />
                            <br />
                            <br />
                            <div className="form-group">
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    disabled={!uploadReport?.can_create}
                                    className="form-control-file"
                                    id="additionalReportFile"
                                    onChange={fileChange}
                                />
                            </div>
                            <br />
                            <div>
                                <LoadingButton
                                    disabled={!uploadReport?.can_create || !reportName || !selectedFile}
                                    loading={uploadLoad}
                                    type="submit"
                                    variant="outlined"
                                >
                                    Upload
                                </LoadingButton>
                            </div>
                        </Form>
                    </div>
                </div>

                <br />
                {loadingReports && (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </div>
                )}
                {!loadingReports && reports.length === 0 && <div style={{ color: 'grey' }}>No additional reports uploaded yet.</div>}
                {reports.map((report, index) => (
                    <Card
                        key={report.id}
                        sx={{
                            minWidth: 300,
                            borderRadius: '10px',
                            border: '1px solid #E6E6E6',
                            background: '#FFF',
                            boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.12)',
                            margin: '20px 0px'
                        }}
                    >
                        <CardHeader
                            title={
                                <div style={{ display: 'flex', alignItems: 'baseline', gap: '16px' }}>
                                    <span>{report.report_name}</span>
                                    {report.created_at && (
                                        <span style={{ fontSize: '0.8rem', fontWeight: 400, color: '#EAFFF8' }}>
                                            {moment(report.created_at).format('Do MMMM YYYY, h:mm A')}
                                        </span>
                                    )}
                                </div>
                            }
                            sx={{ background: '#1B99DF' }}
                            titleTypographyProps={{ style: { color: '#FFF' } }}
                            action={
                                <div>
                                    {report.pdf_url && (
                                        <Button
                                            onClick={() => toggleCard(index)}
                                            variant="outlined"
                                            sx={{
                                                background: '#EAFFF8',
                                                color: '#2D59D2',
                                                marginRight: '20px',
                                                ':hover': { bgcolor: '#2D59D2', color: '#FFFFFF' }
                                            }}
                                        >
                                            View Existing Report
                                        </Button>
                                    )}
                                    <IconButton onClick={() => toggleCard(index)} aria-label="expand" size="small">
                                        {openCardIndex === index ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                    </IconButton>
                                </div>
                            }
                        />
                        <div style={{ backgroundColor: 'rgba(211,211,211,0.4)' }}>
                            <Collapse in={openCardIndex === index} sx={{ bgcolor: '#FFF' }} timeout="auto" unmountOnExit>
                                <CardContent>
                                    <Container sx={{ height: '100%', lineHeight: 2 }}>
                                        {report.pdf_url && (
                                            <div style={{ display: 'flex', flexDirection: 'column', height: '60vh', width: '100%' }}>
                                                <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                                                    <ZoomIn>
                                                        {(props) => (
                                                            <Button variant="contained" style={{ color: '#ffffff' }} onClick={props.onClick}>
                                                                Zoom In
                                                            </Button>
                                                        )}
                                                    </ZoomIn>
                                                    <ZoomOut>
                                                        {(props) => (
                                                            <Button
                                                                variant="contained"
                                                                style={{ color: '#ffffff', margin: '0px 5px' }}
                                                                onClick={props.onClick}
                                                            >
                                                                Zoom Out
                                                            </Button>
                                                        )}
                                                    </ZoomOut>
                                                    <Zoom>
                                                        {(props) => (
                                                            <Button
                                                                variant="contained"
                                                                style={{ color: '#ffffff' }}
                                                                onClick={() => props.onZoom(SpecialZoomLevel.PageFit)}
                                                            >
                                                                Reset Zoom
                                                            </Button>
                                                        )}
                                                    </Zoom>
                                                    <Zoom>
                                                        {(props) => (
                                                            <Button
                                                                variant="contained"
                                                                style={{ color: '#ffffff' }}
                                                                onClick={() => props.onZoom(SpecialZoomLevel.PageWidth)}
                                                            >
                                                                Full Zoom
                                                            </Button>
                                                        )}
                                                    </Zoom>
                                                </div>
                                                <div style={{ display: 'flex', height: '55vh' }}>
                                                    <div style={{ width: '200px', borderRight: '1px solid #ddd', overflowY: 'auto' }}>
                                                        <Thumbnails />
                                                    </div>
                                                    <div style={{ flex: 1, overflow: 'hidden' }}>
                                                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                                            <Viewer
                                                                fileUrl={report.pdf_url}
                                                                viewMode={ViewMode.SinglePage}
                                                                defaultScale={SpecialZoomLevel.PageWidth}
                                                                plugins={[thumbnailPluginInstance, zoomPluginInstance, selectionModePluginInstance]}
                                                            />
                                                        </Worker>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Container>
                                </CardContent>
                            </Collapse>
                        </div>
                    </Card>
                ))}
            </MainCard>
        </div>
    );
};

export default UploadAdditionalReport;
